import 'scss/services/isv.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { config } from 'config'

initServiceOpen()
$(function () {
  $('.to-service-open').click(function () {
    showserviceOpenModal()
  })
  serviceQA()
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/isv.js